import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-794fb0af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "energy-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "储能监控", -1))
const _hoisted_3 = { class: "chart-item" }
const _hoisted_4 = { class: "chart-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "储能充电速率", -1))
const _hoisted_6 = { class: "chart" }
const _hoisted_7 = { class: "chart-item" }
const _hoisted_8 = { class: "chart-title" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "储能放电速率", -1))
const _hoisted_10 = { class: "chart" }

import { onBeforeUnmount, onMounted } from 'vue'
import { useEnergyAnalysisStats } from '../useEnergyAnalysisStats'
import Chart from './Chart.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
  stationId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props


const { chargeEnergy, dischargeEnergy, fetchEssStationEnergyMonitor } = useEnergyAnalysisStats()

let timer: number | undefined

onMounted(() => {
  timer = window.setInterval(() => fetchEssStationEnergyMonitor(props.stationId), 5000)
})

onBeforeUnmount(() => {
  clearInterval(timer)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", null, _toDisplayString(_unref(chargeEnergy)) + "W/分钟", 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Chart, {
          "has-line": false,
          value: _unref(chargeEnergy)
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", null, _toDisplayString(_unref(dischargeEnergy)) + "W/分钟", 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(Chart, {
          "has-line": false,
          color: "#36E1FC",
          value: _unref(dischargeEnergy)
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})